import { render, staticRenderFns } from "./SnapshotFileList.vue?vue&type=template&id=473f76b2&scoped=true&"
import script from "./SnapshotFileList.vue?vue&type=script&lang=js&"
export * from "./SnapshotFileList.vue?vue&type=script&lang=js&"
import style0 from "./SnapshotFileList.vue?vue&type=style&index=0&id=473f76b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473f76b2",
  null
  
)

export default component.exports